import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import QuestionSection from "Components/Utilities/QuestionSection";

import AgendaIndex2 from 'Pages/Agenda/index2';

import { asset } from "Services/BaseHelpers";

export default class Programme extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <Authenticated title="Dashboard">
                <PageHeader
                   title={"The Programme"}
                   imgSrc={'programme-hero.png'}
                />

                {this.renderOpeningTextSection()}
                {this.renderAgendaSection()}

                <QuestionSection />
            </Authenticated>
        );
    }

    /**
     * @method renderOpeningTextSection
     * @return {*}
     */
    renderOpeningTextSection () {
        return (
            <Section>
                <p className={"bmw-condenced-bold text-2xl"}>
                    WHAT’S IN STORE
                </p>
                <p className={"bmw-condenced-bold"}>
                    During your time in Cape Town, you’ll explore everything the city has to offer from
                    amazing culinary experiences to cultural insights and a range of activities on offer.
                </p>
            </Section>
        )
    }

    /**
     * @method renderAgendaSection
     * @return {*}
     */
    renderAgendaSection () {
        return (
            <div className="bg-deadline">
                <Section>
                    <div className="text-sm w-full bg-white text-left p-6">
                        <AgendaIndex2 />
                    </div>
                </Section>
            </div>
        );
    }
}
